// Guardrails Config Service - Company-level AI guardrails CRUD

import { get, post, putWithoutDeduplication as put, del, postWithoutDeduplication } from "../utils/apiUtils";

const BASE_URL = "/api/v1/mms_ai_configs/guardrails/config";

export const fetchConfigs = async ({ filter = {}, sort = {}, skip = 0, limit = 10 } = {}) => {
  return post(`${BASE_URL}/fetch`, { filter, sort, skip, limit });
};

export const fetchCount = async ({ filter = {}, sort = {} } = {}) => {
  return post(`${BASE_URL}/count`, { filter, sort, skip: 0, limit: 0 });
};

export const getByCode = async (code) => {
  return get(`${BASE_URL}/get_by_cd/${encodeURIComponent(code)}`);
};

export const getById = async (id) => {
  return get(`${BASE_URL}/get_by_id/${encodeURIComponent(id)}`);
};

export const createConfig = async (payload) => {
  return postWithoutDeduplication(`${BASE_URL}/`, payload);
};

export const updateConfig = async (payload) => {
  return put(`${BASE_URL}/`, payload);
};

export const deleteById = async (id) => {
  return del(`${BASE_URL}/delete_by_id/${encodeURIComponent(id)}`);
};

export default {
  fetchConfigs,
  fetchCount,
  getByCode,
  getById,
  createConfig,
  updateConfig,
  deleteById,
};
